import { Component, OnInit } from '@angular/core';
import { PlayerService } from 'src/app/features/handball/player/controller/player.service';
import { Player, PlayerListItem } from 'src/app/features/handball/player/model/player';
import { PlayerSelectorComponent } from 'src/app/features/handball/player/view/player-selector/player-selector.component';
import { PlayerStatsComponent } from 'src/app/features/handball/player/view/player-stats/player-stats.component';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.scss'],
  standalone: true,
  imports: [PlayerSelectorComponent, PlayerStatsComponent],
})
export class PerformanceComponent implements OnInit {

  player: Player

  constructor(
    private playerService: PlayerService
  ) { }

  ngOnInit() {
  }

  onPlayerSelected(playerListItem: PlayerListItem) {
    this.player = this.playerService.getPlayers().find((player) => player.id === playerListItem.id);
  }

}
